import _ from "lodash";
import { graphql } from "lib/apolloClient";
import { getOpeningMessageResourcesQuery } from "./AITutorChatModalQueries";
import { getIsAITutorModalitiesEnabled } from "Utils/ACLStoreUtils";

export const getOpeningMessageResourcesEnhancer = graphql(
  getOpeningMessageResourcesQuery,
  {
    name: "getOpeningMessageResources",
    skip: ({ assessmentId }) =>
      !getIsAITutorModalitiesEnabled() || !assessmentId,
    options: ({ assessmentId }) => ({
      fetchPolicy: "cache-and-network",
      variables: { id: assessmentId },
    }),
    props({ getOpeningMessageResources }) {
      const data = _.get(getOpeningMessageResources, "node", {});
      const networkStatus = _.get(getOpeningMessageResources, "networkStatus");

      // we're fetching only one field hence accessing fields[0]
      const openingMessageAttachmentGroups = _.get(
        data,
        "fields.0.resolvedMinimalTree.attachmentGroups",
        []
      );

      const attachments = _.chain(openingMessageAttachmentGroups)
        .flatMap(group => group?.attachments)
        .compact()
        .value();

      return {
        openingMessageResources: attachments,
        isData: !_.isEmpty(data),
        isLoading: _.includes([1, 2], networkStatus),
        isLoadingOpeningMessageResources: _.includes([1, 2], networkStatus),
      };
    },
  }
);
